<template>
  <base-layout>
  <template v-slot:header>
    <app-header/>
  </template>
  <template v-slot:default>
   <HomeDisplay/>
  </template>

  <template v-slot:footer>
   <app-footer/>
  </template>
</base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import HomeBanner from '@/components/HomeBanner'
import HomeDisplay from '@/components/HomeDisplay'
import BaseLayout from '@/layout/BaseLayout'

export default {
  components: {
    BaseLayout,
    AppHeader,
    HomeBanner,
    HomeDisplay,
    AppFooter
  },
  mounted () {
    window.analytics.page('Home - Variant')
  },
  data () {
    return {
      count: 0
    }
  },
  methods: {
  }
}
</script>
<style>
 .clickable {
   cursor:pointer
 }
</style>



// WEBPACK FOOTER //
// src/pages/Welcome.vue